import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(theme => ({
  container: {
    marginLeft: 20,
  },
  notebookImg: {
    display: 'block',
  },
  orderNumber: {
    margin: '0px 6px',
    fontSize: theme.fonts.sizes.font16PX,
    fontWeight: 700,
    lineHeight: 'unset',
    color: theme.colors.orange.orange,
  },
  orderButton: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: 1,
    borderRadius: 7,
    backgroundColor: 'transparent',
    borderColor: theme.colors.orange.peru,
    borderWidth: 1,
    borderStyle: 'solid',
  },
}));
